export default __webpack_public_path__ + "static/media/17.4bc581eb.jpg";